<div class="hf-footer-wrapper" *ngIf="!hideFooter">
  <div class="content">
    <div class="img-wrapper">
      <img src="/assets/images/health-first/hf-logo-light.svg" alt="health first logo">
    </div>
    <div class="desc">
      {{info.desc}}
    </div>
  </div>
  <div class="links">
    <div class="top-text" *ngIf="!util.isMobile()">
      {{info.links.topText}}
    </div>
    <div class="social-media">
      <a [href]="item.link" target="_blank" *ngFor="let item of info.links.socialLinks">
        <span class="social-item" >
          <i [class]="item.icon + ' icon'"></i>
        </span>
      </a>
    </div>
    <div class="top-text" *ngIf="util.isMobile()">
      {{info.links.topText}}
    </div>
  </div>
</div>